module.exports = __webpack_public_path__ + "static/snorkel_wachtlijst_2-9241e2ef851c88a02cba3350c3bbc01a.svg";